<template>
  <div class="contract-pdf-container">
    <div id="pdf"></div>
  </div>
</template>
<script>
import Pdfh5 from 'pdfh5';

export default {
  name: 'ContractPdf',
  data() {
    return {
      pdfh5: null,
    };
  },
  mounted() {
    this.getPdfUrl();
  },
  methods: {
    async getPdfUrl() {
      const { pdfUrl } = this.$route.params;
      this.pdfh5 = new Pdfh5('#pdf', { pdfurl: pdfUrl, lazy: true });
    },
  },
};
</script>
<style lang="scss" scoped>
 /deep/ .viewerContainer {
    height: 100vh;
  }
</style>
